import { FETCH_UNITS } from "./index"

export const fetchUnits = action => {
    return {
        type: FETCH_UNITS,
    }
}